<template>
    <div class="warp">
    <!-- 面包屑 -->
      <breadcrumb :back="true" :crubList="[{name:'审核管理'},{name:'会员单位审核',goback:true},{name:'申请单位详情'}]" :title="'申请单位详情'"/>
      <div class="box">
        <el-card class="basic box_card" header="认证信息" shadow="never">
          <el-row>
            <el-col :span="8">
              <div class="child">
            <div class="name">申请单位名称：</div>
            <div class="content">{{ dataInfo.companyName || '--' }}</div>
          </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">分类</div>
                <div class="content">{{ dataInfo.classifyValue || '--' }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">行业</div>
                <div class="content">{{ dataInfo.industryName || '--' }}</div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="child">
                <div class="name">LOGO：</div>
                <div class="content">
                  <el-avatar shape="square" :src="dataInfo.logoUrl"></el-avatar>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            
            <el-col :span="8">
              <div class="child">
                <div class="name">公司简介：</div>
                <div class="content">
                  {{dataInfo.intro}}
                </div>
              </div>
            </el-col>
            
            
          </el-row>
        </el-card>
        
      </div>
    </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
export default {
  components: {
    breadcrumb
  },
  data() {
    return {
      authorities: JSON.parse(window.localStorage.getItem('authorities')),
      tab: '1', //选项卡
      id: '', //详情id
      dataInfo: {}, //详细信息
      dataInfos: {
        
      },
      center: {}, //地图中心点
      maker: {}, //标记点
      zoom: 15, //缩放等级
    }
  },
  methods: {
    //获取数据
    async getData() {

      // this.$axiosc.get('backstage/incubator/details/' + id)
      const { code, data, msg } = await this.$axiosc.get(
        '/backstage/vipUnit/findVipUnitDetails/' + this.id,
      )
      if (code == 200) {
        this.dataInfo = data
          this.maker = { lng: data.longitude, lat: data.latitude }
          this.center = { lng: data.longitude, lat: data.latitude }
      } else {
        this.$alert(msg)
      }
    },
    //地图创建
    async handler({ BMap, maps }) {
      this.center = this.center
      this.marker = this.marker
    },
  },
  created() {
    const {type,id} = this.$route.params
    this.tab = type || '1'
    this.id = id
  },
  mounted() {
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box{
  height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
  // margin-top: 20px;
  &_card {
    border: none;
    &::v-deep {
      .el-card__header {
        font-size: 16px;
        color: #262626;
        padding: 14px 22px !important;
        border-bottom-color: #e5e5e5;
      }
      .el-card__body {
        padding: 24px 25px !important;
      }
    }
  }
}
.basic {
  color: $font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col {
    margin: 10px 0;
  }
  .child {
    color: #595959;
  }
}
.main {
  background: transparent !important;
  padding: 0 !important;
}
</style>
